import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "../styles.module.css";

const HomePage = () => {
  const navigate = useNavigate();

  const handleRedirect = (path) => {
    navigate(path);
  };

  return (
    <div className={styles.loginSelectionContainer}>
      <h2 className={styles.loginTitle}>Select Login Type</h2>
      <div className={styles.cardContainer}>
        {/* Admin Card */}
        <div className={styles.selectionCard}>
          <div className={styles.iconContainer}>
            <span
              role="img"
              aria-label="Admin Emoji"
              className={styles.cardIcon}
            >
              🛠️
            </span>
          </div>
          <h3 className={styles.cardHeading}>Admin</h3>
          <p className={styles.cardDescription}>
            Access admin features and manage the system.
          </p>
          {/* Single Admin button in a flex container */}
          <div style={{ display: "flex", justifyContent: "center", gap: "1rem" }}>
            <button
              className={styles.cardButton}
              onClick={() => handleRedirect("/admin-login")}
            >
              Admin Login
            </button>
          </div>
        </div>

        {/* Company Card */}
        <div className={styles.selectionCard}>
          <div className={styles.iconContainer}>
            <span
              role="img"
              aria-label="Company Emoji"
              className={styles.cardIcon}
            >
              🏢
            </span>
          </div>
          <h3 className={styles.cardHeading}>Company</h3>
          <p className={styles.cardDescription}>
            Manage company assessments and users.
          </p>
          {/* Wrap buttons in a flex container */}
          <div style={{ display: "flex", justifyContent: "center", gap: "1rem" }}>
            <button
              className={styles.cardButton}
              onClick={() => handleRedirect("/company-login")}
            >
               Login
            </button>
            {/* Only this line changed to "/company-register" */}
            <button
              className={styles.cardButton}
              onClick={() => handleRedirect("/company-register")}
            >
              Register
            </button>
          </div>
        </div>

        {/* User Card */}
       
      </div>
    </div>
  );
};

export default HomePage;
